import {
  Card,
  CardTitle,
  CardHeader,
  CardContent,
  CardDescription,
} from '@design-system/Card';

import { Image } from '@design-system/Image';
import { StatusIndicator } from '@design-system/StatusIndicator';
import { getFormulaImageUrl } from '@/utils/nutrition/getFormulaImageUrl';

export interface FormulaCardProps extends React.ComponentProps<'div'> {
  title: string;
  formulaSrc?: string;
  isSubscribed?: boolean;
  ingredientsCount?: number;
  isCustom?: boolean;
}

export const FormulaCard = ({
  title,
  formulaSrc,
  isSubscribed,
  ingredientsCount,
  isCustom = false,
}: FormulaCardProps) => {
  const getCardDescription = () => {
    if (!isCustom) return 'Made for you';

    if (title === 'Supplements') return '';
    if (title === 'Gut Formula') return 'Gut Formula';
    if (title === 'Toothpaste & Gel') return 'Toothpaste & Gel';
    if (title === 'Oral Lozenges') return 'Oral Lozenges';
    return '';
  };

  const getCardTitle = () => {
    if (!isCustom) return title;

    if (title === 'Gut Formula') return 'Gut Biotics';
    if (title === 'Toothpaste & Gel') return 'Oral Biotics';
    if (title === 'Oral Lozenges') return 'Oral Biotics';
    return title;
  };

  const description = getCardDescription();
  const displayTitle = getCardTitle();

  const getCountText = () => {
    if (isSubscribed) return 'Subscribed';
    if (isCustom) return `${ingredientsCount} recommendations`;
    return `${ingredientsCount} ingredients`;
  };

  return (
    <Card variant="glass" className="h-56">
      <CardHeader className="px-5 pt-6 pb-0">
        <CardTitle className="typography-title text-primary text-center truncate">
          <abbr title={title} className="no-underline">
            {displayTitle}
          </abbr>
        </CardTitle>

        {description && (
          <>
            {!isCustom ? (
              <CardDescription className="typography-title font-serif italic text-center font-light text-primary">
                {description}
              </CardDescription>
            ) : (
              <CardDescription className="typography-caption2 text-center text-primary pb-4">
                {description}
              </CardDescription>
            )}
          </>
        )}
      </CardHeader>

      <CardContent className="flex flex-col items-center gap-4 px-5 pt-0 pb-6">
        {formulaSrc && (
          <Image
            aria-hidden
            width={88}
            height={88}
            className="size-20 object-contain"
            src={getFormulaImageUrl(formulaSrc)}
          />
        )}

        {isSubscribed && (
          <span className="typography-caption1 text-tertiary flex flex-row gap-1 items-center">
            <StatusIndicator color="#009E82" />
            Subscribed
          </span>
        )}

        {!isSubscribed && !!ingredientsCount && (
          <span className="typography-caption1 text-tertiary">
            {getCountText()}
          </span>
        )}
      </CardContent>
    </Card>
  );
};
